import { Usuario } from "@/types/usuario";
import useAuth from "@/components/hooks/use.auth";
import { useParams } from "react-router-dom";

// Usuário tem a permissão na empresa (tenant) atual; o servidor valida de novo em cada chamada

export const temPermissao = (usuario: Usuario | null, tenant: string | undefined, permissao?: string) => {
  if (!permissao) return true;
  const roles = usuario?.empresas?.find(e => e.id === tenant)?.roles;
  return !!roles && (roles.includes('ROLE_ADMIN') || roles.includes(`ROLE_${permissao}`));
}

// Própria senha: USUARIO_CHANGE_PASSWORD; de outro usuário: USUARIO_CHANGE_ALL_PASSWORD
export const podeAlterarSenha = (usuario: Usuario | null, tenant: string | undefined, idUsuario?: string) =>
  temPermissao(usuario, tenant, idUsuario === usuario?.id ? 'USUARIO_CHANGE_PASSWORD' : 'USUARIO_CHANGE_ALL_PASSWORD');

// Permissão do usuário logado na corretora da URL
export const usePermissao = (permissao?: string) => {
  const auth = useAuth();
  const { tenant } = useParams();
  return temPermissao(auth.user, tenant, permissao);
}
